export default __webpack_public_path__ + "static/media/visa.b88a0294.jpg";